export default "__VITE_ASSET__BF1wkw57__"